module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-06-570x470.b7b4d944.jpg";